const getters = {
  getLangList: state => {
    return state.langList
  },
  // 页面信息
  getIndexInfo: state => {
    return state.IndexInfo
  },
  getMenuList: state => {
    return state.menuList
  },
  getVW: state => {
    return state.ViewportWidth
  },
}
export default getters
